import Commissions from "./components/Commissions";

export default Commissions;
